const Footer = () => {
  return (
    <>
      <div className="mb-20 text-center">
        <h3>
          Made with ❤️ by{' '}
          <a href="http://www.instagram.com/diimasaziiz" rel="noreferrer" target={'_blank'}>
            Sandekala
          </a>
        </h3>
      </div>
    </>
  );
};
export default Footer;
